module.exports = __webpack_public_path__ + "static/media/katarina-win.834c9afb.png";